import {fetch} from '../utils/fetch'
import {casaApiUrl} from '../configs/casa-api'
import _ from 'lodash'
import moment from "moment-timezone";


function getCurrentUser() {
  let token = sessionStorage.getItem("authentication");
  const searchParams = new URLSearchParams(location.search);
  const isUserSpecific =
    (searchParams.has("token") && searchParams.has("loadTokenFromUrl")) ||
    false;
  let baseUrl = `${casaApiUrl}/users`;
  if (isUserSpecific) baseUrl += "?userSpecific=true";
  return fetch(baseUrl, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Authorization':  'Bearer ' + token
    }
  }).then((response) => {
    if (response.status === 200) {
      return response.json()
    } else {
      return Promise.reject('login failed')
    }
  })
}

function sendOtp(email) {
  let body = {email: email}
  return fetch(`${casaApiUrl}/otp/forgot-password/sendOTP`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(r => r.json())
}

function resetPassword(body) {
  return fetch(`${casaApiUrl}/auth/change-password`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(r => r.json())
}

function hasRole(user, role) {
  return _.some(_.get(user, 'tenant_role_groups', []), g => _.toLower(g.name) === _.toLower(role))
}

function getUserRole(user) {
  return _.head(_.get(user, 'tenant_role_groups', []))
}

function routeStringTemplate(routeString){
  let templateVariables = _.template(routeString)
  let startDate = moment().subtract(1, 'days').toDate()
  let endDate = moment().toDate()
  let startDateParam = moment(startDate).format('YYYY-MMM-DD')
  let endDateParam = moment(endDate).format('YYYY-MMM-DD')
  return templateVariables({ 'endDate': endDateParam,'startDate': startDateParam})
}

function getDefaultBusinessUnitName(user) {
  let tags = _.get(_.find(_.get(user, 'tenant_stores', []), s => !!s.store), 'tags')
  return _.get(_.head(_.filter(tags, {'type': 'businessUnit'})), 'value')
}

function getDefaultBusinessUnit(user) {
  // let businessUnitName = getDefaultBusinessUnitName(user)
  let businesses = _.get(user, 'tenant.brands[0].businesses')
  businesses = _.sortBy(businesses, 'id')
  return _.head(businesses)
}

function getAllBusinessUnit(user) {
  return _.flatMap(_.get(user, 'tenant.brands'), 'businesses')
}

function getCustomerTags(user, businessUnit) {
  let businessUnitName = businessUnit || getDefaultBusinessUnitName(user)
  let businesses = getAllBusinessUnit(user)
  let business = _.find(businesses, {name: businessUnitName})
  return _.get(business, 'customerTags', [])
}

function getUserTenantStoreBusinessUnits(user) {
  const userBusiness = getAllBusinessUnit(user)

  if (hasRole(user, 'admin')) {
    return userBusiness
  }

  const tenantStores = _.get(user, 'tenant_stores', [])
  const uniqStoreBusiness = _.map(
    _.uniqBy(tenantStores, 'tenantBrandBusinessId'),
    'tenantBrandBusinessId'
  )
  return _.filter(userBusiness, ({id}) => uniqStoreBusiness.includes(id))
}

function getCustomerTagsByStores(user) {
  return _.flatten(
    _.map(getUserTenantStoreBusinessUnits(user), "customerTags")
  )
}

function getAllCustomerTags(user) {
  return {
    defaultCustomerTags: getCustomerTags(user),
    customerTagsGroupedByBu: getCustomerTagsByStores(user)
  }
}

async function getLastOpt(mobile) {
  return await fetch(`${casaApiUrl}/users/data/otp?mobile=${mobile}`, {
    method: 'GET',
    credentials: 'include',
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    if (response.status === 200) {
      return response.json(response)
    } else {
      // Promise.reject('login failed')
      return response.json(response)
    }
  })
}

function isPartnerAdmin(user) {
  return hasRole(user, 'partner_admin')
}

function isCustomerAssociate(user) {
  return hasRole(user, 'customer_associate')
}

function getUserPermissions(user) {
  let roleGroups = _.get(user, 'tenant_role_groups', [])
  let userPerms = []

  for (let i = 0; i < roleGroups.length; i++) {
    let currPerms = (_.get(roleGroups[i], 'permissions'))
    if(Array.isArray(currPerms)){
      userPerms = _.concat(userPerms,currPerms)
    }
    else{
      userPerms = _.concat(userPerms,_.flatMap(_.map(Object.values(currPerms),perm=>perm.enabled)))
    }
  }

  return userPerms

}

function doRoleGroupsExist(user) {
  let roleGroups = _.get(user, 'tenant_role_groups', [])
  return roleGroups.length !== 0
}

function getTenantBusinesses(user) {
  return _.orderBy(_.flatMap(_.get(user, 'tenant.brands'), 'businesses'), ['id'], ['asc'])
}

async function getAllMemberships(tenantId) {
  return await fetch(`${casaApiUrl}/users/${tenantId}/all`, {
    method: 'GET',
    credentials: 'include',
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    return response.json(response)
  })
}

function getOtp(body) {
  return fetch(`${casaApiUrl}/otp/loyalty-otp-generate`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    }
  }).then(r => r.json())
}

function sendOtpToUser(sendOtpBody){
  return fetch(`${casaApiUrl}/flow-otp/generate-for/custom-otp-auth`, {
    method: 'POST',
    body: JSON.stringify(sendOtpBody),
    headers: {
      'Content-Type': 'application/json',
    }
  }).then(r => r.json())
}

function generateOTP(sendOtpBody, key){
  return fetch(`${casaApiUrl}/flow-otp/generate-for/${key}`, {
    method: 'POST',
    body: JSON.stringify(sendOtpBody),
    headers: {
      'Content-Type': 'application/json',
    }
  }).then(r => r.json())
}

function validateOTP(body,key){
  return fetch(`${casaApiUrl}/flow-otp/verify-for/${key}`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    }
  }).then(r => r.json())
}


function getPosToken(id){
  return fetch(`${casaApiUrl}/users/get-token/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  }).then(r => r.json())
}


function getAliasByBusiness(body) {
  return fetch(`${casaApiUrl}/users/store/alias-map`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(r => r.json())
}

export default {
  getCurrentUser,
  hasRole,
  isCustomerAssociate,
  getAllMemberships,
  getUserPermissions,
  doRoleGroupsExist,
  getDefaultBusinessUnit,
  getCustomerTags,
  getCustomerTagsByStores,
  getAllCustomerTags,
  getTenantBusinesses,
  isPartnerAdmin,
  getLastOpt,
  sendOtp,
  resetPassword,
  getUserRole,
  routeStringTemplate,
  sendOtpToUser,
  getPosToken,
  getOtp,
  generateOTP,
  validateOTP,
  getAliasByBusiness,
  getUserTenantStoreBusinessUnits
}



// WEBPACK FOOTER //
// ./src/services/user-service.js